import React, { useState, useEffect } from 'react';
import {
  Box,
  Text,
  HStack,
  IconButton,
  VStack,
  useColorModeValue,
  Tooltip
} from '@chakra-ui/react';
import { Eye, EyeSlash } from '@phosphor-icons/react';

const SiteLocationsList = ({ 
  subLocations, 
  isOwner, 
  onEditSubLocation, 
  onDeleteSubLocation,
  onVisibilityChange
}) => {
  const [hiddenLocations, setHiddenLocations] = useState({});
  
  // Theme colors
  const bgColor = useColorModeValue('gray.100', 'gray.800');
  
  const toggleLocationVisibility = (locationId) => {
    const newHiddenState = {
      ...hiddenLocations,
      [locationId]: !hiddenLocations[locationId]
    };
    setHiddenLocations(newHiddenState);
    if (onVisibilityChange) {
      onVisibilityChange(newHiddenState);
    }
  };

  // Initialize all locations as visible
  useEffect(() => {
    if (subLocations && subLocations.length > 0) {
      const initialState = {};
      subLocations.forEach(location => {
        initialState[location.id] = false;
      });
      setHiddenLocations(initialState);
      if (onVisibilityChange) {
        onVisibilityChange(initialState);
      }
    }
  }, [subLocations]);

  return (
    <VStack spacing={2} align="stretch">
      {subLocations.map((location) => (
        <Box key={location.id} p={3} bg={bgColor} borderRadius="md">
          <HStack justify="space-between">
            <HStack>
              <Tooltip 
                label={hiddenLocations[location.id] ? "Show on map" : "Hide from map"}
                placement="top"
              >
                <IconButton
                  icon={hiddenLocations[location.id] ? <EyeSlash size={18} /> : <Eye size={18} />}
                  aria-label={hiddenLocations[location.id] ? "Show on map" : "Hide from map"}
                  size="sm"
                  variant="ghost"
                  onClick={() => toggleLocationVisibility(location.id)}
                />
              </Tooltip>
              <Text fontWeight="medium">{location.name}</Text>
            </HStack>
            {isOwner && (
              <HStack spacing={2}>
                <IconButton
                  aria-label="Edit location"
                  size="sm"
                  variant="ghost"
                  colorScheme="blue"
                  onClick={() => onEditSubLocation(location)}
                >
                  Edit
                </IconButton>
                <IconButton
                  aria-label="Delete location"
                  size="sm"
                  variant="ghost"
                  colorScheme="red"
                  onClick={() => onDeleteSubLocation(location.id)}
                >
                  Delete
                </IconButton>
              </HStack>
            )}
          </HStack>
          {location.description && (
            <Text mt={1} fontSize="sm" color={useColorModeValue('gray.600', 'gray.400')} pl={10}>
              {location.description}
            </Text>
          )}
        </Box>
      ))}
    </VStack>
  );
};

export default SiteLocationsList;
